import React from 'react';
import { Icon, Tooltip } from 'Components';
import styles from './OverviewCard.module.scss';

export interface OverviewCardProps {
	value: string | number;
	label: string;
	description: string;
	icon: React.ReactNode;
	tooltip?: string;
}

const OverviewCard: React.FC<OverviewCardProps> = ({
	value,
	label,
	description,
	icon,
	tooltip
}) => {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<span className={styles['status-icon']}>{icon}</span>
				<Tooltip title={tooltip} placement="topRight" overlayClassName={styles.tooltip}>
					<Icon
						type="infoTooltip"
						role="img"
						className={styles['info-icon']}
					/>
				</Tooltip>
			</div>
			<div className={styles.value}>{value}</div>
			<div className={styles.label}>{label}</div>
			<div className={styles.description}>{description}</div>
		</div>
	);
};

export default OverviewCard;
